import { render, staticRenderFns } from "./Palette.vue?vue&type=template&id=045f9ede&scoped=true&"
import script from "./Palette.vue?vue&type=script&lang=js&"
export * from "./Palette.vue?vue&type=script&lang=js&"
import style0 from "./Palette.vue?vue&type=style&index=0&id=045f9ede&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045f9ede",
  null
  
)

export default component.exports